import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { setAGraphHeaders } from '../../utils';

import type { AGraphApiSettings } from '../Base';
import { AW_CORRELATION_MATRIX_API_URL } from './Constants';

export const awCorrelationMatrixApiClient = axios.create();

export const awCorrelationMatrixSettings: AGraphApiSettings = {
  getAladdinApiKey: undefined,
  getConfigurationDirectoryFn: undefined,
  getEnvTypeFn: undefined,
};

awCorrelationMatrixApiClient.interceptors.request.use((config) => {
  const { getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awCorrelationMatrixSettings;

  const baseURL = AW_CORRELATION_MATRIX_API_URL;
  const configurationDirectory = getConfigurationDirectoryFn?.();

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      configurationDirectory,
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());
  return updatedConfig;
});
